@if (hasInsuranceAttribute() && !isAttributeLoading()) {
<h1 class="app__template--linked--header mt-0 mx-0 mb-6 pt-[0] pr-[16px] pl-[0]">Insurance Attributes</h1>
@for ( attribute of attributesList(); track attribute?.value?.order; let i=$index) { @if(!isDynamicAttribute(attribute)){ @if
(!isBalanceAttribute(attribute) ) {
<div class="app__addDocument-card-wrapper pb-0">
  <div class="app__addDocument-card-top">
    <div class="flex flex-col">
      <p class="app__addDocument-card-title">{{ attribute?.value?.title ?? attribute?.key }}</p>
      <p class="text-xs m-0"></p>
    </div>
    <div class="flex full-width">
      <button 
        class="app__addDocument-addButton" 
        [disabled]="isRemoveEditSaveSharing"
        (click)="!isRemoveEditSaveSharing && openFormDialog(attribute?.getFormValues?.attribute, attribute, 'create')">
        <p 
          class="app__form--attribute--add--btn"
          [ngClass]="{ 'hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }">
          <span class="material-icons text-xl">add</span> Update
        </p>
      </button>
    </div>
  </div>
  <div class="app__addDocument-card-bottom pb-0">
    @for (input of attribute?.value?.inputs; track input; let i = $index; let last = $last) {
    <div
      class="app__addDocument-card-bottom-list flex items-center justify-between"
      [ngClass]="{
        'border-0': last == true || i === attribute?.value?.inputs.length - 1
      }"
    >
      <p class="text-sm" [matTooltip]="input?.toolTip">
        {{ input?.title }}
        @if(input?.toolTip){
        <span class="material-icons text-base material-symbols-outlined pl-4" [matTooltip]="input?.toolTip"> info_outlined</span>
        }
      </p>
      <b class="font-semibold text-lg my-[0.5rem]"> </b>
      <b [class]="handleStyleClassForAttributeValues(input, attribute, i)">
        @if(!attribute?.getFormValues ){
        {{ getAttributeItemValue(input) }}
        } @else { @if(input?.type == 'Dollar Input'){
        {{ attribute?.getFormValues[input.key] | currency : 'USD' : true : '1.2-2' }}
        } @else if(input?.type == 'Numeric Input'){
        {{ attribute?.getFormValues[input.key] | number : '1.2-2' }}
        } @else if(input?.type == 'Text Input'){
        {{ !!attribute?.getFormValues[input.key] ? attribute?.getFormValues[input.key] : '-' }}
        } @else if(input?.type == 'Percentage'){
        {{ attribute?.getFormValues[input.key] + '%' }}
        } @else if(input?.type == 'Switch'){
        {{ convertSwitchBooleanValueToString(attribute?.getFormValues[input.key]) }}
        } @else if(input?.key == 'effective_date' || input?.type == 'Date Selection'){
        {{ (attribute?.getFormValues[input.key] | date : 'MMM d yyyy') ?? '-' }}
        } @else{
        {{ attribute?.getFormValues[input.key] ?? '' }}
        } }
      </b>
    </div>
    }
  </div>
</div>
<br />
} @if (isBalanceAttribute(attribute)) {
<app-current-balance-card
  [formData]="data"
  [attribute_type]="'insurance'"
  [attribute]="attribute"
  (openFormDialogEmitter)="openFormDialog(attribute?.getFormValues?.attribute, attribute, 'create', $event)"
  [currentFormId]="currentFormId"
  [connected_to_institution]="connected_to_institution"
  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
  [mode]="mode"
  [templateId]="templateId"
  [insuranceAttributes]="insuranceAttributes"
  (RegisterBalanceComponentEmitter)="handleRegisterBalanceComponentEmitter($event)"
  [attributeClasses]="{
        income_expense_class: income_expense_class,
        attribute_sub_class: attribute_sub_class,
        income_expense_sub_class: income_expense_sub_class,
        attribute_class: attribute_class,
        
          }"
></app-current-balance-card>
<br />
}} @if(isDynamicAttribute(attribute)){
<app-dynamic-attributes
  #dynamicAttributesComponent
  [attributes]="attribute?.value?.inputs"
  [attribute]="attribute"
  [title]="attribute?.value?.title ?? attribute?.key"
  [currentFormId]="currentFormId"
  [attribute_type]="'insurance'"
  [userId]="userId"
  [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
></app-dynamic-attributes>
} } }@else if (hasInsuranceAttribute() && isAttributeLoading()){
<ng-container [ngTemplateOutlet]="loader"></ng-container>
}

<ng-template #loader>
  <h1 class="text-lg font-bold m-0 pt-[0] pr-[16px] pb-[12px] pl-[0]">Insurance Attributes</h1>
  @for ( attribute of attributesList(); track attribute?.value?.order; let i=$index) { @if(!isDynamicAttribute(attribute)){ @if
  (!isBalanceAttribute(attribute) ) {
  <div class="app__addDocument-card-wrapper pb-0">
    <div class="app__addDocument-card-top">
      <div class="flex flex-col">
        <p class="app__addDocument-card-title">{{ attribute?.value?.title ?? attribute?.key }}</p>
        <p class="text-xs m-0"></p>
      </div>
      <div class="flex full-width">
        <button 
          class="app__addDocument-addButton" 
          [disabled]="isRemoveEditSaveSharing"
          (click)="!isRemoveEditSaveSharing && openFormDialog(attribute?.getFormValues?.attribute, attribute, 'create')">
          <p 
            class="app__form--attribute--add--btn"
            [ngClass]="{ 'hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }">
            <span class="material-icons text-xl">add</span> Update
          </p>
        </button>
      </div>
    </div>
    <div class="app__addDocument-card-bottom pb-0">
      @for (input of attribute?.value?.inputs; track input; let i = $index; let last = $last) {
      <div [class]="'app__addDocument-card-bottom-list flex items-center justify-between' + ' ' + (last ? 'border-0' : ' ')">
        <p class="text-sm flex items-center">
          {{ input?.title ?? '' }} @if(input?.toolTip){
          <span class="material-icons text-base material-symbols-outlined pl-2 cursor-pointer mt-1" [matTooltip]="input?.toolTip"> info</span>
          }
        </p>
        <b class="font-semibold text-lg my-[0.5rem]"> </b>
        <b [class]="handleStyleClassForAttributeValues(input, attribute, i)">
          @if(!attribute?.getFormValues ){
          {{ getAttributeItemValue(input) }}
          } @else { @if(input?.type == 'Dollar Input'){
          {{ attribute?.getFormValues[input.key] | currency : 'USD' : true : '1.2-2' }}
          } @else if(input?.type == 'Numeric Input'){
          {{ attribute?.getFormValues[input.key] | number : '1.2-2' }}
          } @else if(input?.type == 'Text Input'){
          {{ !!attribute?.getFormValues[input.key] ? attribute?.getFormValues[input.key] : '-' }}
          } @else if(input?.type == 'Percentage'){
          {{ attribute?.getFormValues[input.key] + '%' }}
          } @else if(input?.type == 'Switch'){
          {{ convertSwitchBooleanValueToString(attribute?.getFormValues[input.key]) }}
          } @else if(input?.key == 'effective_date' || input?.type == 'Date Selection'){
          {{ (attribute?.getFormValues[input.key] | date : 'MMM d yyyy') ?? '-' }}
          } @else{
          {{ attribute?.getFormValues[input.key] ?? '' }}
          } }
        </b>
      </div>
      }
    </div>
  </div>
  <br />
  } @if (isBalanceAttribute(attribute)) {
  <app-current-balance-card
    [formData]="data"
    [attribute_type]="'insurance'"
    [attribute]="attribute"
    (openFormDialogEmitter)="openFormDialog(attribute?.getFormValues?.attribute, attribute, 'create', $event)"
    [currentFormId]="currentFormId"
    [connected_to_institution]="connected_to_institution"
    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
    [mode]="mode"
    [templateId]="templateId"
    [insuranceAttributes]="insuranceAttributes"
    (RegisterBalanceComponentEmitter)="handleRegisterBalanceComponentEmitter($event)"
  ></app-current-balance-card>
  <br />
  }} @if(isDynamicAttribute(attribute)){
  <app-dynamic-attributes
    #dynamicAttributesComponent
    [attributes]="attribute?.value?.inputs"
    [attribute]="attribute"
    [title]="attribute?.value?.title ?? attribute?.key"
    [currentFormId]="currentFormId"
    [attribute_type]="'insurance'"
    [userId]="userId"
    [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
  ></app-dynamic-attributes>
  } }
</ng-template>
